module.exports = __webpack_public_path__ + "static/img/icon4.c073402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon4.png
// module id = K3X3
// module chunks = 4